import { jsx } from "react/jsx-runtime";
import AntTag from "antd/es/tag";
import classnames from "../../utils/classnames.js";
import Typography from "../Typography/Typography.js";
import './Status.css';/* empty css            */
const Status = ({ iconColor, children, className, ...props }) => {
  return /* @__PURE__ */ jsx(
    AntTag,
    {
      color: iconColor,
      icon: /* @__PURE__ */ jsx("div", { className: classnames("perxis-auto-status__icon") }),
      style: {
        "--perxis-auto-status-icon-color": iconColor
      },
      className: classnames("perxis-auto-status", className),
      ...props,
      children: /* @__PURE__ */ jsx(Typography.Text, { level: "marker", color: "darkest", children })
    }
  );
};
export {
  Status as default
};
//# sourceMappingURL=Status.js.map
